// eslint-disable-next-line import/prefer-default-export
export const driverTripFilterParams = {
  query: '',
  dateTo: '',
  dateFrom: '',
  driverFilterTrip: 'actives'
};
